"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostChatMessageArgs = exports.GovernanceChatInstruction = void 0;
var GovernanceChatInstruction;
(function (GovernanceChatInstruction) {
    GovernanceChatInstruction[GovernanceChatInstruction["PostMessage"] = 0] = "PostMessage";
})(GovernanceChatInstruction = exports.GovernanceChatInstruction || (exports.GovernanceChatInstruction = {}));
var PostChatMessageArgs = /** @class */ (function () {
    function PostChatMessageArgs(args) {
        this.instruction = GovernanceChatInstruction.PostMessage;
        this.body = args.body;
    }
    return PostChatMessageArgs;
}());
exports.PostChatMessageArgs = PostChatMessageArgs;
//# sourceMappingURL=instructions.js.map